import React, { Component } from "react";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

import connect from "react-redux/es/connect/connect";
import { trimFormData } from "../../../../utils/common";
import * as validator from "../../../../utils/validator";
import { TRANSACTION_HISTORY } from "../../../../navigation/routes";

import TransactionHistoryView from "./TransactionHistoryView";
import { getNotificationTypeList } from "../../../../store/master/masterActions";
import {
  getPaymentReceiptList,
  //
  updateCurrentPageAndRowLimit,
  updateSearchFilters,
} from "../../../../store/Subscription/SubscriptionManagementActions";

class TransactionHistoryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: {
        notificationType: this.props.searchFilters?.notificationType || "",
      },
      //
      currentPageOfTransactionHistory:
        this.props.currentPageOfTransactionHistory,
      rowsPerPageOfTransactionHistory: {
        label: `${this.props.rowsPerPageOfTransactionHistory}`,
        value: this.props.rowsPerPageOfTransactionHistory,
      },
    };

    //
    this.handleTableRowsChange = this.handleTableRowsChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    //
    this.onClickNotificationTypeMenuFilterOptions =
      this.onClickNotificationTypeMenuFilterOptions.bind(this);
  }

  componentDidUpdate(prevProps, prevStates) {
    const {
      paymentReceiptList,
      currentPageOfTransactionHistory,
      rowsPerPageOfTransactionHistory,
    } = this.props;

    // Check if any relevant props have changed
    const hasChanged =
      prevProps.paymentReceiptList !== paymentReceiptList ||
      prevProps.currentPageOfTransactionHistory !==
        currentPageOfTransactionHistory ||
      prevProps.rowsPerPageOfTransactionHistory !==
        rowsPerPageOfTransactionHistory;

    if (hasChanged) {
      this.setState(
        {
          currentPageOfTransactionHistory,
          rowsPerPageOfTransactionHistory: {
            label: `${rowsPerPageOfTransactionHistory}`,
            value: rowsPerPageOfTransactionHistory,
          },
        },
        () => {
          this.updateReduxStateOfCurrentPageAndRowLimit(false);
        }
      );
    }

    if (prevStates?.searchValue !== this?.state?.searchValue) {
      this.props.updateSearchFilters(this?.state?.searchValue);
    }
  }

  componentDidMount() {
    //call fetch list api
    const { currentPageOfTransactionHistory, rowsPerPageOfTransactionHistory } =
      this.state;
    this.fetchPaymentReceipts(
      currentPageOfTransactionHistory,
      rowsPerPageOfTransactionHistory?.value
    );
    this.props.getNotificationTypeList();
  }

  componentWillUnmount() {
    if (window?.location?.pathname !== TRANSACTION_HISTORY) {
      const resetValue = true;
      this.updateReduxStateOfCurrentPageAndRowLimit(resetValue);

      //reset the search value in redux state
      this.props.updateSearchFilters({});
    }
  }

  //--------------------page handling

  handleTableRowsChange = (value) => {
    this.setState(
      (prev) => ({
        ...prev,
        rowsPerPageOfTransactionHistory: value,
        currentPageOfTransactionHistory: 1,
      }),
      () => {
        const {
          currentPageOfTransactionHistory,
          rowsPerPageOfTransactionHistory,
        } = this.state;
        this.fetchPaymentReceipts(
          currentPageOfTransactionHistory,
          rowsPerPageOfTransactionHistory?.value
        );
      }
    );
  };

  handleChangePage = (page) => {
    this.setState(
      (prev) => ({ ...prev, currentPageOfTransactionHistory: page }),
      () => {
        const {
          currentPageOfTransactionHistory,
          rowsPerPageOfTransactionHistory,
        } = this.state;
        this.fetchPaymentReceipts(
          currentPageOfTransactionHistory,
          rowsPerPageOfTransactionHistory?.value
        );
      }
    );
  };

  updateReduxStateOfCurrentPageAndRowLimit = (
    reset = false,
    preserveTheRows = false
  ) => {
    const currentPage = reset ? 1 : this.state?.currentPageOfTransactionHistory;
    const rowsPerPage =
      reset && !preserveTheRows
        ? 10
        : this.state?.rowsPerPageOfTransactionHistory?.value;

    const pageData = {
      currentPageOfTransactionHistory: currentPage,
      rowsPerPageOfTransactionHistory: rowsPerPage,
    };

    this.props.updateCurrentPageAndRowLimit(pageData); //update the redux state
  };

  //--------------------filter based on notification Type

  onClickNotificationTypeMenuFilterOptions = (value) => {
    // console.log("value", value);
    this.setState(
      (prev) => ({
        ...prev,
        searchValue: {
          ...prev?.searchValue,
          notificationType: value?.type || "",
        },
      }),
      () => {
        // call the fetch list api
        const { rowsPerPageOfTransactionHistory } = this.state;
        this.fetchPaymentReceipts(1, rowsPerPageOfTransactionHistory?.value);
      }
    );
  };

  //--------------------api call

  fetchPaymentReceipts = (
    page = this.state.currentPageOfTransactionHistory,
    limit = this.state.rowsPerPageOfTransactionHistory?.value,
    refresh = false
  ) => {
    // console.log("refresh");

    const { searchValue } = this.state;
    const data = {};

    // Conditionally include 'notificationType' only if it's valid
    if (searchValue?.notificationType) {
      data.notificationType = searchValue.notificationType;
    }

    this.props.getPaymentReceiptList(
      data,
      !refresh ? page : 1,
      // !refresh ? limit : 10,
      limit,
      refresh,
      () => {
        //api callbacks
        const resetValue = true;
        const preserveTheRows = true;
        refresh &&
          this.updateReduxStateOfCurrentPageAndRowLimit(
            resetValue,
            preserveTheRows
          );
      }
    );
  };

  render() {
    const rowsPerPageDropDownOptions = [
      { label: "10", value: 10 },
      { label: "15", value: 15 },
      { label: "20", value: 20 },
      { label: "25", value: 25 },
      { label: "30", value: 30 },
    ];

    const filterBasedOnPersistedData = (options, filteringProperty, id) => {
      var filteredData = [];
      filteredData = options?.filter((item) => item[filteringProperty] === id);
      // console.log("filteredData", filteredData);
      return filteredData?.[0];
    };

    const persistedData = {
      //this is used for check marking selected filter list
      notificationType: filterBasedOnPersistedData(
        this?.props?.notificationTypeList,
        "type",
        this.props.searchFilters?.notificationType
      ),
    };

    const { paymentReceiptList, notificationTypeList } = this.props;
    const { currentPageOfTransactionHistory, rowsPerPageOfTransactionHistory } =
      this.state;

    return (
      <TransactionHistoryView
        //all states
        currentPageOfTransactionHistory={currentPageOfTransactionHistory}
        rowsPerPageOfTransactionHistory={rowsPerPageOfTransactionHistory}
        persistedData={persistedData}
        //select input options
        rowsPerPageDropDownOptions={rowsPerPageDropDownOptions}
        //handler functions
        handleTableRowsChange={this.handleTableRowsChange}
        handleChangePage={this.handleChangePage}
        //
        onClickNotificationTypeMenuFilterOptions={
          this.onClickNotificationTypeMenuFilterOptions
        }
        //list
        paymentReceiptList={paymentReceiptList}
        notificationTypeList={notificationTypeList}
        //api call
        fetchPaymentReceipts={this.fetchPaymentReceipts}
      />
    );
  }
}

TransactionHistoryContainer.propTypes = {
  paymentReceiptList: PropTypes.array.isRequired,
  currentPageOfTransactionHistory: PropTypes.number.isRequired,
  rowsPerPageOfTransactionHistory: PropTypes.number.isRequired,
  getPaymentReceiptList: PropTypes.func.isRequired,
  updateCurrentPageAndRowLimit: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  //list
  paymentReceiptList: state.subscriptionManagement.paymentReceiptList,
  notificationTypeList: state.master.notificationTypeList,
  //
  searchFilters: state.subscriptionManagement.searchFilters,
  //page state
  currentPageOfTransactionHistory:
    state.subscriptionManagement.currentPageOfTransactionHistory,
  rowsPerPageOfTransactionHistory:
    state.subscriptionManagement.rowsPerPageOfTransactionHistory,
});

export default connect(mapStateToProps, {
  //api
  getPaymentReceiptList,
  getNotificationTypeList,
  //
  updateCurrentPageAndRowLimit,
  updateSearchFilters,
})(TransactionHistoryContainer);
